<app-sidebar [(isOpen)]="isSidebarOpen" />
<app-cart-sidebar [(isOpen)]="isCartOpen" />

<header class="header">
  <button class="header__burger burger" (click)="openSidebar()">
    <span class="burger__line"></span>
    <span class="burger__line"></span>
    <span class="burger__line"></span>
  </button>

  <div class="header__logo logo">
    <!--    TODO: Needs to be fixed-->
    @if (restaurantId === "lemongrass") {
      <a href="https://lemongrassthaiandsushi.com/">
        <img
          [src]="restaurant().logo"
          loading="lazy"
          class="logo__image"
          alt="Logo"
        />
      </a>
    } @else if (restaurant().logo) {
      <img
        [src]="restaurant().logo"
        loading="lazy"
        class="logo__image"
        alt="Logo"
      />
    }
    @if (hasMultipleStores()) {
      <button
        type="button"
        class="header__change-location"
        (click)="openStorePicker()"
      >
        Change location
      </button>
    }
  </div>

  @if (headerLinks.length > 0) {
    <nav class="header__nav">
      @for (link of headerLinks; track link.url) {
        <a class="header__nav_link" [href]="link.url" target="_blank" rel="noopener noreferrer">
          {{ link.label }}
        </a>
      }
    </nav>
  }

  <form class="header__location">
    <!--    TODO: According to task https://app.asana.com/1/146640857715300/project/1209401032829742/task/1209970777443390?focus=true -->
    <!--    <app-dropdown-->
    <!--      formControlName="address"-->
    <!--      icon="icon-pin"-->
    <!--      optionLabelName="address_1"-->
    <!--      optionValueName=""-->
    <!--      [options]="addresses"-->
    <!--      (change)="onAddressChange()"-->
    <!--    />-->
  </form>
  <div class="header__cart cart">
    <app-button (click)="openCartSidebar()" [size]="ButtonSize.Small">
      <div class="cart__content">
        <i class="cart__content_icon icon icon-cart"></i>
        <span class="cart__content_label">{{ cartItems().length }}</span>
      </div>
    </app-button>
  </div>
</header>
